import React from 'react';

import {DeveloperPlatformFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {BENCHLING_APPS_WEB_URL, CANVAS_BUILDER_URL} from 'benchling-apps/BenchlingAppDAO';
import BenchlingConfig from 'BenchlingConfig';
import {EVENT_SUBSCRIPTIONS_URL} from 'events/EventsDAO';
import EntityStore from 'stores/EntityStore';

import EmptySidebarIcon from './EmptySidebarIcon';
import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface DeveloperConsoleSettingsProps {
  section: string;
}

export function shouldShowDeveloperConsole(isCurrentUserTenantAdmin: boolean): Boolean {
  const devPlatformEnabled = isFeatureEnabled({
    feature: DeveloperPlatformFeature.DEVELOPER_PLATFORM_DISCOVER,
  });
  const eventsEnabled = BenchlingConfig.EVENTS_ENABLE_UI && isCurrentUserTenantAdmin;
  const benchlingAppsEnabled = BenchlingConfig.ENABLE_BENCHLING_APPS;

  return devPlatformEnabled && (eventsEnabled || benchlingAppsEnabled);
}

export default function DeveloperConsoleSettings(props: DeveloperConsoleSettingsProps): JSX.Element {
  const currentUser = EntityStore.currentUser();
  return (
    <div>
      <div className="browser-nav-header">Developer Console</div>
      {BenchlingConfig.ENABLE_BENCHLING_APPS && (
        <SidebarItem
          active={props.section === SidebarConstants.Section.BENCHLING_APPS_SETTINGS}
          icon={<EmptySidebarIcon />}
          name="Apps"
          link={BENCHLING_APPS_WEB_URL}
        />
      )}
      {BenchlingConfig.ENABLE_BENCHLING_APPS && BenchlingConfig.ENABLE_BENCHLING_APPS_CANVAS_BUILDER && (
        <SidebarItem
          active={props.section === SidebarConstants.Section.BENCHLING_APP_CANVAS_BUILDER}
          icon={<EmptySidebarIcon />}
          name="App Canvas Builder"
          link={CANVAS_BUILDER_URL}
        />
      )}
      {BenchlingConfig.EVENTS_ENABLE_UI && currentUser?.isTenantAdmin && (
        <SidebarItem
          active={props.section === SidebarConstants.Section.EVENT_SUBSCRIPTIONS}
          icon={<EmptySidebarIcon />}
          name="Events"
          link={EVENT_SUBSCRIPTIONS_URL}
        />
      )}
    </div>
  );
}
